import { render, staticRenderFns } from "./iconHottub.vue?vue&type=template&id=4b194498"
import script from "./iconHottub.vue?vue&type=script&lang=js"
export * from "./iconHottub.vue?vue&type=script&lang=js"
import style0 from "./iconHottub.vue?vue&type=style&index=0&id=4b194498&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports